<template>
  <div class="cropper">
    <el-upload
      action=""
      :multiple="false"
      :show-file-list="false"
      :before-upload="getFile">
      <el-button v-if="!$slots.default" size="small" type="primary">选择文件</el-button>
      <slot></slot>
    </el-upload>
    <Dialog v-model="show" title="图片裁剪" footer :padding="0" appendToBody :closeOnModal="false" :destroyOnClose="false" @change="dialogChange">
      <div class="cropper-contain">
        <VueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :info="option.info"
          :full="option.full"
          :canMoveBox="option.canMoveBox"
          :canScale="option.canScale"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          :fixedBox="option.fixedBox"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
        ></VueCropper>
      </div>
      <div class="cropper-footer" slot="footer">
        <div class="flex-center">
          <el-image class="cropper-footer-icon" @click="stepChange(-1)" :src="lowerIcon"></el-image>
          <div class="cropper-footer-slider">
            <el-slider v-model="scaleVal" :min="-50" :max="50" @input="sliderChange" :show-tooltip="false"></el-slider>
          </div>
          <el-image class="cropper-footer-icon" @click="stepChange(1)" :src="addIcon"></el-image>
        </div>
        <div class="cropper-footer-btns">
          <el-button @click="show = false">取 消</el-button>
          <el-button type="primary" @click="confirm" :loading="confirmLoading">确 定</el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import {
  Upload,
  Slider,
  Image
} from 'element-ui';
import { VueCropper } from 'vue-cropper';

export default {
  name: 'cropper',
  components: {
    'el-upload': Upload,
    'el-slider': Slider,
    'el-image': Image,
    VueCropper,
  },
  props: {
    // 裁剪框宽高比例
    scale: {
      type: Array,
      default: () => [1, 1],
    },
    beforeUpload: {
      type: Function,
      default: file => file
    }
  },
  data() {
    return {
      addIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgCAYAAABpRpp6AAAAAXNSR0IArs4c6QAAAg9JREFUWEfVmL+L1EAUx993Zu20OgyT9SwE0dolgo2onV6l4N9g4R9x4K/WUsFeG7GxsRDUzgPDNgdyZ+uRhJ0u5xbnDHnyZFdW2bvb7GbXTNq8GT55ee/7fiDLMqYVPgB+MHMGICOir0qpt1EUfQTwcxYMrBp4GhSAkoheaq0fRlFUHAX+B7jb7WKWL1zUZjAYnATQ9d6fIaKrzHybiC7JvQCGRPTUGPMEwMHUjxt7eFXA0yCstRe994+Z+e4IfEtrfWeat1fu4aP+UFEUV5j5FTOfI6I9pdSGMWZ78kyrgAWsLMu14XD4hpmvCXSn07k86enWAQs0M58oiuK9QAPYMsZcH8d0K4EnPP1FwgPAoziON3/Hd1NJ1+/3b1VV9UIuVUrd6/V67xZVFInpqqo+i3porc9LaDQGnKbpdyJaH0HuJUlydlFgOZ/n+WtRDwDP4zi+3yTwXxUzSZJGdF0kzzm3I8XFGHO69cDi5SzL+lJctNY3gwDO83yTmR8AeBYK8A1m/gDgU23gCTUYJ9isuSWVay71sNZecM7tEtG32sD/qMGssGO7udRDGibv/b60pkEAW2tPOedKAPu1gYMLicNiIE3TpejwqHjMn3T/CTgsWQuqcCyzNIfV/ATXXtatIMfZj0al5TXwxwHUeR/UiBTUEBrMmN/qRUpjq6o6SdG07VzLwKYhDrtv0XXrL/5p9Bs1arPvAAAAAElFTkSuQmCC',
      lowerIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgCAYAAABpRpp6AAAAAXNSR0IArs4c6QAAAgJJREFUWEfVmL9rFEEUx99bZrTYZLs5dhZto1ikOE7QToUQbGzEJukFLW01CeR/0MK/QdBGtIvBRshxqRXBwrizu2IVO2/2G0Z2j0vYmMthcjvbbLFvZj68/b4f85gmfABcKIridlmW94joGoCEmRMAcxNu8V/M+KRdiqKIrbXrRLQKIDrJ/qy/HwsM4GKWZU+J6AmAsALZZeY3RPRRCPEDQNrpdH6fNaTbP01TuHcjcOXV1wBu/DVifiWEeKaU+nwecE1nHAuc5/mitfYtEV1i5m/MvBLH8adZgdbnNgI7zw6Hw50KdjsMw/tRFP2aNWyjJCrNfnAyYObtOI6XmPlPG2AbgY0xmwDWnAzCMLzeFs82SqIKsq8uGwRBcLMNmj36Zw9p2BjzAsAjlw201g/aIoNxjhGwq2BZlv10RUFKeXWWqetfjhoB53m+bK19T0S7SZJ02+jdQ0FnjHkO4DEzb2itN30A3gJwi5nvaK23Wg+cpqkrtwtSyitKqS+nBR4MBnfLsnzpis0p1+4FQfCw2+2+m2TdSMPGmH3XIgoh5qdpZPr9/vcpYGvGvV6vd3kqYCllpJTan2TxuM25A/soCb+Czru05l3h8K40u4j3qvlxwN61l5WX/WngHbB3V6RaGt5cQuty69U1v4b2apBSQ3s1qhrvxrwZBh5tM9sybj0AvAzGUF+OQNUAAAAASUVORK5CYII=',
      show: false,
      scaleVal: 0,
      oldScaleVal: 0,
      confirmLoading: false,
      cropperFile: {},
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 300, // 默认生成截图框宽度
        autoCropHeight: 300, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false // true 为展示真实输出图片宽高 false图框宽高
      }
    };
  },
  watch: {
    scale: {
      handler(val) {
        if (val && val.length === 2) {
          this.setCropper();
        }
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    this.setCropper();
  },
  methods: {
    /**
     * 设置裁剪框宽高
     */
    setCropper() {
      const w = this.scale[0];
      const h = this.scale[1];
      const windowHeight = document.documentElement.clientHeight; // 视口高度
      // 裁剪组件内容高度为70vh
      const cropHeight = windowHeight * 0.7;
      if (w > h && cropHeight > 750 * (h / w)) {
        // 宽高比中，宽度大于高度，设置裁剪宽度为弹窗最大宽度750px，裁剪高度根据比例计算
        this.option.autoCropWidth = 750;
        this.option.autoCropHeight = 750 * (h / w);
      } else {
        this.option.autoCropHeight = cropHeight;
        this.option.autoCropWidth = cropHeight * (w / h);
      }
      this.option.fixedNumber = this.scale;
    },
    /**
     * 确定
     */
    confirm() {
      this.$refs.cropper.getCropBlob(file => {
        this.cropperFile.size = file.size;
        this.cropperFile.type = file.type;
        if (this.beforeUpload({ ...this.cropperFile }) === false) return;
        const formdata = new FormData();
        formdata.set('upload_file', file);
        this.confirmLoading = true;
        this.request('api_upload', formdata, {}, false).then(res => {
          this.cropperFile.url = res[0].url;
          this.$emit('confirm', { ...this.cropperFile });
          this.confirmLoading = false;
          this.show = false;
        }).catch(() => {
          this.confirmLoading = false;
        });
      });
    },
    /**
     * 弹层开关时
     */
    dialogChange() {
      this.scaleVal = 0;
      this.oldScaleVal = 0;
    },
    /**
     * icon加减
     */
    stepChange(val) {
      this.scaleVal += val;
    },
    /**
     * 滑块变化
     */
    sliderChange(val) {
      if (val === 0) {
        this.$refs.cropper.reload();
        this.oldScaleVal = 0;
        return;
      }
      const num = val - this.oldScaleVal;
      if (num === 0) return;
      this.oldScaleVal = val;
      this.$refs.cropper.changeScale(num);
    },
    /**
     * 获取文件
     */
    getFile(val) {
      this.cropperFile.name = val.name;
      // 使用reader把file文件转换为base64
      const reader = new FileReader();
      reader.onload = e => {
        this.option.img = e.target.result;
        this.show = true;
      }
      reader.readAsDataURL(val);
      // 阻止upload，后面裁剪之后再走接口
      return false;
    },
  },
};
</script>

<style lang='scss' scoped>
.flex-center {
  display: flex;
  align-items: center;
}
.cropper-contain {
  height: 70vh;
  overflow: hidden;
}
.cropper-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .cropper-footer-slider {
    width: 250px;
    background-color: #E4E7ED;
    box-sizing: border-box;
    padding: 0 10px;
    ::v-deep .el-slider__runway {
      border-radius: 0;
      margin: 0;
      height: 16px;
      .el-slider__bar {
        height: 16px;
        background-color: #E4E7ED;
      }
      .el-slider__button-wrapper {
        height: 16px;
        width: 16px;
        top: 0;
        .el-slider__button {
          display: block;
          width: 16px;
          height: 16px;
          box-sizing: border-box;
          background-color: #3642FF;
        }
      }
    }
  }
}
.cropper-footer-icon {
  width: 22px;
  height: 16px;
  cursor: pointer;
}
.cropper-footer-btns {
  ::v-deep .el-button {
    width: 100px;
    box-sizing: border-box;
  }
}
</style>
